import Swiper from "swiper";
import {A11y, FreeMode, Mousewheel, Scrollbar} from "swiper/modules";

export function initSubnav() {
    new Subnav();
}

class Subnav {
    constructor(query = document.querySelector(".js-subnav")) {
        if (!query) return;
        this.swiperInstance = null;
        this.swiperContainer = query.querySelector(".js-subnav-slider");
        this.mediaQueryListener = window.matchMedia("(max-width: 1249px)");
        this.mediaQueryListener.addEventListener("change", () => {
            this.initViewportBehavior();
        });

        this.initViewportBehavior();
    }

    initViewportBehavior() {
        if (!this.swiperContainer) return;

        if (this.mediaQueryListener.matches) {
            this.buildSwiperMarkup();
            this.initSwiper();
        } else {
            this.destroySwiper();
            this.destroySwiperMarkup();
        }
    }

    buildSwiperMarkup() {
        this.swiperContainer.classList.add("swiper");
        const mainSubNavigation = this.swiperContainer.querySelector(".level_1.nav--shop, .level_1.nav--content");
        if (!mainSubNavigation) return;

        mainSubNavigation.classList.add("swiper-wrapper");
        const slides = mainSubNavigation.querySelectorAll(":scope > li");
        slides.forEach((slide) => {
            slide.classList.add("swiper-slide");
        });

        if (!this.swiperContainer.querySelector(".swiper-scrollbar")) {
            const paginationEl = document.createElement("div");
            paginationEl.className = "swiper-scrollbar";
            this.swiperContainer.appendChild(paginationEl);
        }
    }

    destroySwiperMarkup() {
        this.swiperContainer.classList.remove("swiper");

        const mainSubNavigation = this.swiperContainer.querySelector(".level_1.nav--shop");
        if (!mainSubNavigation) return;

        mainSubNavigation.classList.remove("swiper-wrapper");
        const slides = mainSubNavigation.querySelectorAll(":scope > li");
        slides.forEach((slide) => {
            slide.classList.remove("swiper-slide");
        });

        const scrollbar = this.swiperContainer.querySelector(".swiper-scrollbar");
        if (scrollbar) scrollbar.remove();
    }

    destroySwiper() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    }

    initSwiper() {
        const scrollbarEl = this.swiperContainer.querySelector(".swiper-scrollbar");
        if (!scrollbarEl) return;
        if (this.swiperInstance) {
            this.destroySwiper();
        }
        Swiper.use([Scrollbar, Mousewheel, A11y, FreeMode]);
        this.swiperInstance = new Swiper(this.swiperContainer, {
            slidesPerView: "auto",
            mode: "horizontal",
            spaceBetween: 12,
            a11y: {
                slideRole: null,
                slideLabelMessage: null
            },
            mousewheel: {
                forceToAxis: true
            },
            freeMode: {
                sticky: true
            },
            scrollbar: {
                el: scrollbarEl,
                draggable: true,
                hide: false,
                snapOnRelease: true
            }
        });
    }
}
